import React from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import { useTheme } from '@material-ui/core/styles'
import HelpTips from 'app/main/composeMessage/HelpTips'
import { useAppName } from 'commons/usePartner'
import { IconButton, Icon, useMediaQuery, Divider } from '@material-ui/core'
import PropTypes from 'prop-types'
import { SettingIcon, HelpIcon } from 'app/components/icons'
import { useIsPaidPlan } from 'app/auth/paidPlanAccess'
import { FormattedMessage } from 'react-intl'
import IosSwitchFormik from 'app/components/IosSwitchFormik'
import { useFlag } from '@unleash/proxy-client-react'

const useStyles = makeStyles(() => ({
  rigthBar: {
    // marginRight: '6.1rem !important',
  },
  boxTab: {
    boxShadow: '0 0 1px 0 rgba(0,0,0,0.2) !important',
  },
  topBar: {
    boxShadow: '0 1px rgba(0,0,0,0.10) !important',
  },
}))

const ComposeRightTab = (props) => {
  const {
    isShowHelpTab,
    isShowSettingTab,
    onCloseRightTab,
    onHandleTtsdisabled,
    onSharingEnabledChange,
    isSharingEnabled,
    isBeaconDialog = false,
    onClickStartTour,
    isEditMode,
    isPoll = false,
  } = props

  const appName = useAppName()
  const classes = useStyles()
  const isPaidPlan = useIsPaidPlan()
  const theme = useTheme()
  const isDownXs = useMediaQuery(theme.breakpoints.down('xs'))
  const mes_4386_dashbooard_chats_coming_soon = useFlag(
    'mes_4386_dashbooard_chats_coming_soon',
  )

  if (!isShowHelpTab && !isShowSettingTab) {
    return null
  }

  return (
    <div
      className={clsx(
        'bg-white h-screen',
        isDownXs ? 'flex-1' : 'w-320',
        classes.rigthBar,
      )}
    >
      <div
        className={clsx(
          'flex flex-col h-full',
          isDownXs && 'w-full',
          isShowHelpTab ? 'block' : 'hidden',
          classes.boxTab,
        )}
      >
        <div className={clsx('h-56 p-5 flex justify-between', classes.topBar)}>
          <div className="flex p-auto space-x-3">
            <div className="flex m-auto">
              <HelpIcon color="#183560" classes="w-20" />
            </div>
            <label className="py-2 font-medium text-16 text-blue-950 flex align-autoplay">
              <FormattedMessage id="composeDialog.help.label" />
            </label>
          </div>
          <div className="flex p-auto">
            <IconButton
              aria-label="Icon button close right tab"
              className="text-sm rounded-full w-36 p-0"
              onClick={onCloseRightTab}
            >
              <Icon className="text-20">close</Icon>
            </IconButton>
          </div>
        </div>
        <HelpTips
          appName={appName}
          onClickStartTour={onClickStartTour}
          className="p-5 m-2 overflow-y-auto h-full"
        />
      </div>
      <div
        className={clsx(
          'h-full flex flex-col',
          isDownXs && 'w-full',
          isShowSettingTab ? 'block' : 'hidden',
          classes.boxTab,
        )}
      >
        <div className={clsx('h-56 p-5 flex justify-between', classes.topBar)}>
          <div className="flex p-auto space-x-3">
            <div className="flex m-auto">
              <SettingIcon color="#183560" classes="w-20" />
            </div>
            <label className="py-2 font-medium text-16 text-blue-950 flex align-autoplay">
              <FormattedMessage id="createNotification.dialog.messageSettings" />
            </label>
          </div>
          <div className="flex p-auto">
            <IconButton
              aria-label="Icon button close right tab"
              className="text-sm rounded-full w-36 p-0"
              onClick={onCloseRightTab}
            >
              <Icon className="text-20">close</Icon>
            </IconButton>
          </div>
        </div>
        <div className="p-5">
          {isPaidPlan && (
            <div>
              {mes_4386_dashbooard_chats_coming_soon ? (
                <div className="text-14 text-blue-950 p-14 my-5 bg-primary-200 rounded-8 flex flex-col gap-12">
                  <div>
                    <FormattedMessage id="conversations.new.comingSoon.title" />
                  </div>
                  <div>
                    <FormattedMessage id="conversations.new.comingSoon.subtitle" />
                  </div>
                </div>
              ) : (
                <div className="flex justify-between mt-5 md:mt-3 mb-5 pb-5">
                  <div className="w-fit pr-5">
                    <div className="font-bold text-14 text-blue-950">
                      <FormattedMessage id="navigation.conversation.label" />
                    </div>
                    <div className="text-14 leading-tight mt-3 text-grey-400">
                      <FormattedMessage id="createNotification.dialog.options.conversation.tooltip" />
                    </div>
                  </div>
                  <IosSwitchFormik
                    name="allowConversation"
                    disabled={isBeaconDialog && isEditMode}
                    inputProps={{
                      'data-testid': `allowConversation`,
                    }}
                  />
                </div>
              )}
              <Divider className="my-2 w-full" />
              <div className="flex justify-between  my-5 pb-5">
                <div className="w-fit pr-5">
                  <div className="font-bold text-14 text-blue-950">
                    <FormattedMessage id="createNotification.dialog.allowTts" />
                  </div>
                  <div className="text-14 leading-tight mt-3 text-grey-400">
                    <FormattedMessage id="createNotification.dialog.options.tts.tooltip" />
                  </div>
                </div>
                <IosSwitchFormik
                  name="isTtsEnabled"
                  disabled={isPoll}
                  onChange={(event) => {
                    if (!event) onHandleTtsdisabled()
                  }}
                  inputProps={{
                    'data-testid': `isTtsEnabled`,
                  }}
                />
              </div>
              <Divider className="my-2 w-full" />
            </div>
          )}
          <div>
            <div className="my-5 pb-5">
              <div className="flex justify-between ">
                <div className="w-fit pr-5">
                  <div className="font-bold text-14 text-blue-950">
                    <FormattedMessage id="createNotification.dialog.shareMessage" />
                  </div>
                  <div className="w-fit text-14 leading-tight mt-3 text-grey-400">
                    <FormattedMessage
                      id="createNotification.dialog.options.shareable"
                      values={{ appName }}
                    />
                  </div>
                </div>
                <IosSwitchFormik
                  name="isSharingEnabled"
                  onChange={onSharingEnabledChange}
                  disabled={isBeaconDialog}
                  inputProps={{
                    'data-testid': `isSharingEnabled`,
                  }}
                />
              </div>
              {isSharingEnabled && (
                <ul className="w-fit text-14 leading-tight mt-3 pl-10 text-grey-400">
                  <li>
                    <div className="flex justify-between w-full mt-3">
                      <div className="w-fit pr-5">
                        <FormattedMessage id="createNotification.dialog.options.message.history" />
                      </div>
                      <IosSwitchFormik
                        name="isDisplayHistory"
                        disabled={isBeaconDialog}
                        inputProps={{
                          'data-testid': `isDisplayHistory`,
                        }}
                      />
                    </div>
                  </li>
                </ul>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ComposeRightTab

ComposeRightTab.propTypes = {
  isShowHelpTab: PropTypes.bool.isRequired,
  isShowSettingTab: PropTypes.bool.isRequired,
  onCloseRightTab: PropTypes.func.isRequired,
  onHandleTtsdisabled: PropTypes.func.isRequired,
  onSharingEnabledChange: PropTypes.func.isRequired,
  isSharingEnabled: PropTypes.bool.isRequired,
  onClickStartTour: PropTypes.func.isRequired,
}
